import { concat, uniq } from 'lodash-es';

// eslint-disable-next-line no-restricted-syntax
import * as FCM_CONFIGS from '@change-corgi/fcm/configs';
import type { FcmConfig } from '@change-corgi/fcm/configs';

/**
 * Type guard for arrays — widened to `any[] | readonly any[]` to work around
 * https://github.com/microsoft/TypeScript/issues/17002.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isArray(value: unknown): value is any[] | readonly any[] {
	return Array.isArray(value);
}

export type FcmAdminConfig = Omit<FcmConfig, 'merger'> & {
	type: 'json' | 'number' | 'string' | 'boolean';
};

export const FCM_ADMIN_CONFIGS = Object.values(FCM_CONFIGS).reduce<Record<string, FcmAdminConfig>>(
	(
		acc,
		{
			normalizer,
			defaultValue,
			name,
			supportedGroups,
			owner,
			scope,
			context,
			description,
			mergeLogic,
			template,
			deprecated,
		}: FcmConfig<any, any>, // eslint-disable-line @typescript-eslint/no-explicit-any
	) => {
		if (!name) {
			// skipping default export
			return acc;
		}
		// eslint-disable-next-line no-param-reassign
		acc[name] = {
			name,
			normalizer,

			defaultValue,
			supportedGroups,
			owner,
			scope,
			context,
			description,
			mergeLogic,
			template,
			deprecated,
			// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
			type: (normalizer as any).type as 'number' | 'string' | 'boolean' | 'json',
		};
		return acc;
	},
	{},
);

const OWNERS = [
	...uniq(Object.values(FCM_ADMIN_CONFIGS).map((config) => config.owner))
		.toSorted()
		.filter((owner) => owner !== 'TBD'),
	'TBD',
];

const SCOPES = [
	...uniq(
		concat(
			...Object.values(FCM_ADMIN_CONFIGS).map((config) => (isArray(config.scope) ? config.scope : [config.scope])),
		),
	)
		.toSorted()
		.filter((scope) => scope !== 'TBD'),
	'TBD',
];

export function getFcmAdminConfig(name: string): FcmAdminConfig | undefined {
	return FCM_ADMIN_CONFIGS[name];
}

export function getFcmAdminConfigNames(): readonly string[] {
	return Object.keys(FCM_ADMIN_CONFIGS);
}

export function getOwners(): readonly string[] {
	return OWNERS;
}

export function getScopes(): readonly string[] {
	return SCOPES;
}
